import { Children, cloneElement, useEffect, useState } from 'react';
import find from 'lodash/find';

import { participate } from './index';

// SSR experiments must handle participate() in Page.getInitialProps
// and supply the "forceVariant" prop from the result.
const Experiment = ({ name, forceVariant, children }) => {
  const [activeVariant, setActiveVariant] = useState(forceVariant || null);

  const alternatives = Children.map(children, child => ({
    name: child.props.name,
    child
  }));

  const alternativeNames = alternatives.map(entry => entry.name);

  useEffect(
    () => {
      (async function execute() {
        const alternative = await participate(name, alternativeNames);
        setActiveVariant(alternative);
      })();
    },
    [name, alternativeNames]
  );

  if (activeVariant) {
    const result = find(alternatives, { name: activeVariant });
    if (result && result.child) {
      return result.child;
    }
  }

  return null;
};

const Variant = ({ children, isDefault }) => {
  return children || null;
};

const Conversion = ({ children, experimentName }) => {
  return Children.map(children, child => {
    return cloneElement(child, {
      url: null,
      to: {
        pathname: child.props.url,
        state: { trackConversion: experimentName }
      }
    });
  });
};

export { Variant, Conversion };

export default Experiment;
